import { z } from 'zod';
import { ZodArrayToEnum } from '@axiom/types';
import { OpportunitiesConst } from '@axiom/const';

import { AccountAccountTypes } from './account';
import { OpportunitySchema } from './opportunity';
import { AfcSubmissionPositionSchema } from './afc-submission-position';
import { AfcSubmissionContactSchema } from './afc-submission-contact';

export const AfcSubmissionProjectStates = Object.values(
  OpportunitiesConst.ProjectStates
);

export const AfcSubmissionSchema = OpportunitySchema.pick({
  accountName: true,
  addressCountryCode: true,
  addressState: true,
  confidential: true,
  currency: true,
  id: true,
  isQualificationComplete: true,
  jobName: true,
  primaryFocusArea: true,
  primaryPracticeArea: true,
  salesLead: true,
  salesforceContactId: true,
  salesforceId: true,
  selfService: true,
  submissionId: true,
  submissionLastUpdatedAt: true,
}).extend({
  accountType: z.enum(ZodArrayToEnum(AccountAccountTypes)).nullable(),
  contacts: z.array(AfcSubmissionContactSchema).nullish(),
  editable: z.boolean(),
  positions: z.array(AfcSubmissionPositionSchema),
  projectState: z.enum(ZodArrayToEnum(AfcSubmissionProjectStates)),
});

export type AfcSubmission = z.infer<typeof AfcSubmissionSchema>;
